import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Navbar } from './Navbar';

export const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-200">
      <Navbar />

      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </main>

      <footer className="border-t border-slate-200/80 dark:border-slate-800 bg-white/50 dark:bg-slate-900/50 py-6 text-center text-xs text-slate-500 dark:text-slate-400 mt-auto">
        <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div>
            &copy; {new Date().getFullYear()} <strong>QUiNVOICE</strong>. Todos los derechos reservados.
          </div>
          <div className="flex items-center gap-4 text-xs">
            <span className="inline-flex items-center gap-1.5 text-brand-600 dark:text-brand-400 font-medium">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-ping" />
              API Server Online
            </span>
            <Link to="/profile" className="hover:text-brand-600 dark:hover:text-brand-400 transition-colors">
              Ajustes
            </Link>
            <Link to="/subscriptions" className="hover:text-brand-600 dark:hover:text-brand-400 transition-colors">
              Planes
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
